export default __webpack_public_path__ + "static/media/2left.78ba3451.png";